<template>
  <div>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <header-card
        v-if="showDetailHeader"
        icon="terrain"
        title="Goal Management"
        sub-title="Create & manage goals in CoreCounts"
      >
        <template v-slot:right>
          <goal-avatars :statuses="statuses"></goal-avatars>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-row dense>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <v-btn
                text
                to="/reporting/goals/tracking"
                color="secondary"
                block
              >
                <v-icon class="mr-2">assessment</v-icon>
                Reporting
              </v-btn>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <timeframe-select
                v-model="filter"
                v-on:change="getGoals"
                solo
                flat
                :outlined="false"
                embed
                hide-custom
                small
              ></timeframe-select>
            </v-col>
            <template v-if="canEdit">
              <v-divider
                vertical
                v-if="$vuetify.breakpoint.mdAndUp"
              ></v-divider>
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
                class="my-auto"
              >
                <v-btn text color="secondary" @click="showDialog" block>
                  <v-icon color="success" class="mr-2">
                    add_circle
                  </v-icon>
                  Add Goal
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </template>
      </header-card>
      <v-row v-masonry="masonryId">
        <v-col
          v-masonry-tile="masonryId"
          cols="12"
          sm="6"
          lg="4"
          v-for="(goal, i) in sorted_goals"
          :key="i"
        >
          <goal
            :goal="goal"
            :canEdit="canEdit"
            v-on:redraw="redrawMasonry"
            v-on:save="$emit('save')"
          ></goal>
        </v-col>
      </v-row>
      <edit-goal-dialog ref="addGoal"></edit-goal-dialog>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditGoalDialog from "@/components/goals/EditGoalDialog";
import Goal from "@/components/goals/Goal";
import HeaderCard from "@/components/common/HeaderCard";
import GoalAvatars from "@/components/goals/GoalAvatars";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
export default {
  name: "Goals",
  props: {
    user: { type: Object },
    team: { type: Object },
    showDetailHeader: { type: Boolean, default: false },
    getData: { type: Boolean, default: false },
    filter: { type: Object },
    editIds: { type: Array }
  },
  components: {
    Goal,
    EditGoalDialog,
    HeaderCard,
    GoalAvatars,
    TimeframeSelect
  },
  data: () => ({
    loading: false,
    masonryId: "goal-masonry-grid"
  }),
  computed: {
    canEdit() {
      if (this.editIds && this.editIds.length > 0) {
        return this._.includes(this.editIds, this.profile.id);
      }
      if (!this.user) {
        return false;
      }
      return (
        this.profile.id == this.user.id ||
        this.profile.id == this.user.directManagerId
      );
    },
    statuses() {
      return this.goal_statuses.map(x =>
        Object.assign(x, {
          count: this.goals.filter(y => y.statusId == x.id).length
        })
      );
    },
    sorted_goals() {
      return this._.orderBy(
        this.goals,
        ["completeDate", "dueDate"],
        ["desc", "asc"]
      );
    },
    ...mapGetters({
      goals: "goal/list",
      goal_statuses: "lookup/goal_statuses",
      profile: "profile/profile"
    })
  },
  created() {
    this.getGoals();
  },
  methods: {
    redrawMasonry() {
      let self = this;
      setTimeout(function() {
        self.$redrawVueMasonry(self.masonryId);
      }, 200);
    },
    showDialog() {
      this.$refs.addGoal.showDialog({ user: this.user }, []);
    },
    getGoals() {
      if (!this.getData) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("goal/getGoals", this.filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading goals."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
